import { action, runInAction, set } from 'mobx';
import Config from '../../domain/entities/Config';

export enum OPTIMIZELY_FLAGS {
  MELISSA = 'isMelissaExperimentEnabled',
  GIFT_WRAP_AND_DONATIONS = 'isGiftWrapAndDonationsHidingExperimentEnabled',
}

interface IOptimizelyServiceConfig {
  config: Config;
}

export default class OptimizelyService {
  private config: Config;

  constructor({ config }: IOptimizelyServiceConfig) {
    this.config = config;
  }

  public init(): void {
    // TODO: All optimizely experiment event listeners will be removed from here on RCO-9428
    this.observeOptimizelyExperimentEvent({ // Optimizely event for activating Melissa on CL US
      experimentId: '24246430199',
      flag: OPTIMIZELY_FLAGS.MELISSA,
      variationId: '24249030376',
    });
    this.observeOptimizelyExperimentEvent({ // Optimizely event for activating Melissa on CL BR
      experimentId: '27947910485',
      flag: OPTIMIZELY_FLAGS.MELISSA,
      variationId: '28018720077',
    });
    this.observeOptimizelyExperimentEvent({
      experimentId: '29718300004',
      flag: OPTIMIZELY_FLAGS.GIFT_WRAP_AND_DONATIONS,
      variationId: '29661790401',
    });
  }

  @action
  private observeOptimizelyExperimentEvent = ({ experimentId, variationId, flag }: {
    experimentId: string,
    flag: OPTIMIZELY_FLAGS,
    variationId: string,
  }): void => {
    let variation;

    // Check if Optimizely is loaded
    window.optimizely = window.optimizely || [];
    if ('get' in window.optimizely) { // If get method is present we can assume is loaded
      const data = window.optimizely.get('state');
      const experiment = data?.getExperimentStates()?.[experimentId];
      variation = experiment?.variation?.id === variationId; 
    }

    if (variation) { // Event already fired, variation is already set
      set(this.config, flag, true);
    } else { // Set listener that will enable FF when event is fired
      window.optimizely.push({
        filter: {
          name: 'campaignDecided',
          type: 'lifecycle',
        },
        handler: event => {
          const decision = event?.data?.decision;
          if (decision?.experimentId === experimentId && decision?.variationId === variationId) {
            runInAction(() => { set(this.config, flag, true); });
          }
        },
        type: 'addListener',
      });
    }
  };

}
